export type XAdsEventPayload = Record<string, boolean | number | string | null | undefined>;

const ATTRIBUTION_PARAMS = [
  'twclid',
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
] as const;

const ATTRIBUTION_STORAGE_KEY = 'pythra-attribution';

const X_ADS_EVENT_IDS: Record<string, string | undefined> = {
  // activation: process.env.NEXT_PUBLIC_X_ADS_EVENT_ACTIVATION,
  click_event_card: 'tw-rd7g3-rd7vo',
  click_download_app: 'tw-rd7g3-rd7vr',
  click_news_card: 'tw-rd7g3-rd7vp',
  click_market: 'tw-rd7g3-rd7vq',
  click_pre_question: process.env.NEXT_PUBLIC_X_ADS_EVENT_CLICK_PRE_QUESTION,
  login_success: process.env.NEXT_PUBLIC_X_ADS_EVENT_LOGIN_SUCCESS,
  onboarding_finish: process.env.NEXT_PUBLIC_X_ADS_EVENT_ONBOARDING_FINISH,
  user_search_chat: process.env.NEXT_PUBLIC_X_ADS_EVENT_USER_SEARCH_CHAT,
  bind_wallet: '',
};

declare global {
  interface Window {
    twq?: (...args: unknown[]) => void;
  }
}

function configuredEventId(eventName: string) {
  return X_ADS_EVENT_IDS[eventName];
}

export function trackXAdsEvent(eventName: string, payload: XAdsEventPayload = {}) {
  if (typeof window === 'undefined') return;

  const eventId = configuredEventId(eventName);
  if (!eventId || !window.twq) return;

  const attribution = readStoredAttribution();
  const cleanedPayload = Object.fromEntries(
    Object.entries({ ...attribution, ...payload }).filter(
      ([, value]) => value !== undefined && value !== '',
    ),
  );

  window.twq('event', eventId, cleanedPayload);
}

export function captureCurrentAttribution() {
  if (typeof window === 'undefined') return;

  const params = new URLSearchParams(window.location.search);
  const attribution = Object.fromEntries(
    ATTRIBUTION_PARAMS.map((param) => [param, params.get(param)]).filter(([, value]) => value),
  );

  if (!Object.keys(attribution).length) return;

  try {
    window.localStorage.setItem(ATTRIBUTION_STORAGE_KEY, JSON.stringify(attribution));
  } catch {
    // Ignore storage failures; X Ads base tracking still works.
  }
}

export function readStoredAttribution(): XAdsEventPayload {
  if (typeof window === 'undefined') return {};

  try {
    const stored = window.localStorage.getItem(ATTRIBUTION_STORAGE_KEY);
    if (!stored) return {};
    const parsed = JSON.parse(stored) as unknown;
    if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
    return parsed as XAdsEventPayload;
  } catch {
    return {};
  }
}
